export interface Palette {
  id: number;
  ssccnummer: string;
  auslieferungsstatus: Auslieferungsstatus;
  artikelmengen: {
    menge: number;
    menge_offen: number;
    einheit: any;
    artikel: any;
  }[];
}

export enum Auslieferungsstatus {
  Lager = 'L',
  Beladen = 'B',
  Entladen = 'E',
}
